<div class="container-fluid">
    <div class="row">
         <div class="alignMenu shadow text-left pt-2 px-1" [ngClass]="companyId == 36 ? 'col-md-3 col-lg-2' : 'col-lg-2 col-xl-2'">
      <app-rental-menu (companyIdSevenMile)="companyIdSevenMile($event)"></app-rental-menu>
    </div>
        <div class="bgMainSection bgBlue text-left" style="height: 50px" [ngClass]="companyId == 36 ? 'col-md-9 col-lg-10' : 'col-lg-10 col-xl-10'">
            <div class="row">
                <div class="col-5 py-2">
                    <div class="container mainContainer mt-2">
                        <h2 class="txtHead">Dashboard</h2>
                    </div>
                </div>
                <div [ngClass]="SwapORamaCustomChanges ? 'col-7 col-lg-5 text-right py-2 mt-2' : 'col-7 text-right py-2 bgHead'">
                    <div class="container mainContainer">
                        <h1 class="txtHead">{{marketName}}</h1>
                    </div>
                </div>
                <div class="col-12 col-lg-2 text-left text-lg-right pl-0 mt-3" *ngIf="SwapORamaCustomChanges">
                    <a class="text-white language-toggle translator" style="text-decoration: none !important;" translate="no" href="javascript:void(0)" onclick="toggleLanguage()">Español</a>
                </div>
            </div>
            <div class="container mainContainer">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-1 col-xl-1 mt-2">
                        <img src="./assets/images/availableBooths.png" class="img-fluid" alt="Vendor Icon">
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 mt-2">
                        <p class="mt-2 message" style="white-space: pre-wrap;" [innerHTML]="message1">
                        </p> <br />
                        <p class="mt-2 message" style="white-space: pre-wrap;" [innerHTML]="message2">
                        </p> <br />
                        <p class="mt-2 message" style="white-space: pre-wrap;" [innerHTML]="message3">
                        </p> <br />
                        <p class="mt-2 message" style="white-space: pre-wrap;" [innerHTML]="message4">
                        </p> <br />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-4">
                        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                              <li data-target="#carouselExampleIndicators" *ngIf="imageURL1" data-slide-to="0" [class.active]="getFirstVisibleIndex() === 0"></li>
                              <li data-target="#carouselExampleIndicators" *ngIf="imageURL2" data-slide-to="1" [class.active]="getFirstVisibleIndex() === 1"></li>
                              <li data-target="#carouselExampleIndicators" *ngIf="imageURL3" data-slide-to="2" [class.active]="getFirstVisibleIndex() === 2"></li>
                            </ol>
                            <div class="carousel-inner" style="background: black;">
                              <div class="carousel-item" *ngIf="imageURL1" [class.active]="getFirstVisibleIndex() === 0">
                                <img [src]="imageURL1" class="img-fluid imgCarousel" style="width: 100%;" alt="Dashboard Image 1">
                              </div>
                              <div class="carousel-item" *ngIf="imageURL2" [class.active]="getFirstVisibleIndex() === 1">
                                <img [src]="imageURL2" class="img-fluid imgCarousel" style="width: 100%;" alt="Dashboard Image 2">
                              </div>
                              <div class="carousel-item"  *ngIf="imageURL3" [class.active]="getFirstVisibleIndex() === 2">
                                <img [src]="imageURL3" class="img-fluid imgCarousel" style="width: 100%;" alt="Dashboard Image 3">
                              </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                              <span class="sr-only d-none">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                              <span class="carousel-control-next-icon" aria-hidden="true"></span>
                              <span class="sr-only d-none">Next</span>
                            </a>
                          </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-1 col-xl-1 mt-3 mb-3">
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 mt-3 mb-3">
                        <button [routerLink]="['/map', marketId]" class="btn btn-primary" *ngIf="!HideWRMarketMap">View Market Map</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>